<div class='widget-action'>
  <div *ngIf='showLoader' class='widget-action--loader'>
    <div class='spinner-border spinner-border-sm' role='status'>
      <span class='visually-hidden'>Loading...</span>
    </div>
  </div>

  <div *ngIf='showEdit'
       [ngClass]='{"cursor-not-allowed": disabledEdit}' class='widget-action--edit'>
    <button
      (click)='clickEdit.emit(); $event.stopPropagation()'
      [disabled]='disabledEdit'
      [ngClass]="{
          'btn-success': actionStyle === 'BUTTON',
          'btn-link': actionStyle === 'TEXT',
          'cursor-not-allowed': disabledEdit
        }"
      class='btn btn-sm btn-success btn-widget'>
      <pt-icon *ngIf='showIcon' [key]='IconEdit' [size]='IconSize'></pt-icon>
      {{ 'BUTTON.EDIT' | translate }}
    </button>
  </div>
  <div *ngIf='showSave'
       [ngClass]='{"cursor-not-allowed": disabledSave}' class='widget-action--save'>
    <button
      (click)='clickSave.emit(); $event.stopPropagation()'
      [disabled]='disabledSave'
      [ngClass]="{
        'btn-success' : actionStyle === 'BUTTON',
        'btn-link' : actionStyle === 'TEXT',
        'cursor-not-allowed': disabledSave
      }"
      class='btn btn-sm btn-success btn-widget'>
      <pt-icon *ngIf='showIcon' [key]='IconSave' [size]='IconSize'></pt-icon>
      {{ 'BUTTON.SAVE' | translate }}
    </button>
  </div>

  <div *ngIf='showCancel'
       [ngClass]='{"cursor-not-allowed": disabledCancel}' class='widget-action--cancel'>
    <button
      (click)='clickCancel.emit(); $event.stopPropagation()'
      [disabled]='disabledCancel'
      [ngClass]="{
        'btn-outline-secondary' : actionStyle === 'BUTTON',
        'btn-link' : actionStyle === 'TEXT',
        'cursor-not-allowed': disabledCancel
        }"
      class='btn btn-sm btn-widget'>
      {{ 'BUTTON.CANCEL' | translate }}
    </button>
  </div>

  <div *ngIf='showReload'
       [ngClass]='{"cursor-not-allowed": disabledReload}' class='widget-action--reload'>
    <button
      (click)='clickReload.emit(); $event.stopPropagation()'
      [disabled]='disabledReload'
      [ngClass]="{
        'btn-light' : actionStyle === 'BUTTON',
        'btn-link' : actionStyle === 'TEXT',
        'cursor-not-allowed': disabledReload
        }"
      class='btn btn-sm btn-widget'>
      <pt-icon [key]='IconReload' [size]='IconSize'></pt-icon>
    </button>
  </div>

</div>
